<template>
    <div>
        <nav class="breadcrumb-dark">
            <ul class="breadcrumb-dark__list">
                <li class="breadcrumb-dark__level">
                    <span class="breadcrumb-dark__link">Self Serve Updates by ParkAve</span>
                </li>
            </ul>
            <div class="breadcrumb-dark__select-preview select-preview" v-if="sidebarActive" data-v-config-step="4">
                <label class="select-preview__label">Display size: </label>
                <p class="size__display">{{ getSize }}</p>
            </div>
        </nav>
        <section class="main-content main-content--white-background" v-bind:class="{'main-content--full-width': sidebarActive}">

            <section class="main-content__full section" v-bind:class="{'section--sidebar': sidebarActive}">
                <form class="section__content section__content--form form">

                    <fieldset class="form__group">

                        <article class="form__item">
                            <label class="form__item__label">
                                <h1 class="form__item__name">Advertisement Name</h1>
                                <small class="form__item__description">This is the advertisement chosen for self serve. This cannot be changed.</small>
                            </label>

                            <section class="form__item__input input">
                                <input type="text" class="input__field" disabled="disabled" v-model="settings.name" />
                            </section>
                        </article>

                        <article class="form__item" v-for="(field, index) in update_fields">
                            <label class="form__item__label">
                                <h1 class="form__item__name">{{field.label}}</h1>
                                <small class="form__item__description">{{field.description}}</small>
                            </label>

                            <item :id="getFormName(field.type, index)" v-model="settings[field.name]" :defaultValue="settings[field.name]" :item="field" v-if="!field.array" />
                            <array-item :id="getFormName(field.type, index)" v-model="settings[field.name]" :defaultValue="settings[field.name]" :item="field" v-if="field.array" />
                        </article>
                    </fieldset>
                </form>

                <section class="section__content section__content--preview">
                    <article class="section__content__preview preview">
                        <header class="preview__header" v-if="!sidebarActive">
                            <h1 class="preview__title">Preview</h1>
                        </header>

                        <preview-settings data-v-config-step="3" ref="preview" v-on:preview-data="onPreviewData" :ad="ad" :inputs="settings"></preview-settings>

                        <footer class="preview__footer" v-if="!sidebarActive">
                            <ul class="preview__details details">
                                <li class="details__item">
                                    Preview Size: <strong class="details__item__value">{{preview.length}} Bytes</strong>
                                </li>

                                <li class="details__item details__item--preview detail__item__select-preview">
                                    <div class="select-preview select-preview--light select-preview--small">
                                        <label class="select-preview__label">Preview size</label>
                                        <size-input selectClass="select-preview__select" v-model="settings['size']" :defaultValue="settings['size']" :options="sizeItem().options" v-if="sizeItem()" />
                                    </div>

                                </li>

                                <!--<li class="details__item">
                                  Dimension: <strong class="details__item__value">600x388</strong>
                                </li>-->

                                <!--<li class="details__item details__item--right">
                                  <a href="#" class="detail__full-size">View original size</a>
                                </li>-->
                            </ul>
                        </footer>
                    </article>

                    <hr class="seperator" v-if="!sidebarActive" />

                    <footer class="section__footer">
                        <ul class="details" v-if="sidebarActive">
                            <li class="details__item">
                                <span v-if="preview.scale < 100"><strong class="details__item__value">Note:</strong> Scaled down for preview</span>
                            </li>
                        </ul>

                        <a href="#" v-on:click="save($event, false)" class="section__footer__button section__footer__button--right button button--secondary button--ghost" v-bind:class="{ 'button--disabled': !settings.name || (settings.name && settings.name.length < 3) }">Submit for Approval</a>
                    </footer>
                </section>
            </section>
        </section>
    </div>
</template>

<script>
  import store from '../store'
  import ArrayItem from './configurator/ArrayItem.vue'
  import Item from './configurator/Item.vue'
  import SizeInput from './configurator/SizeInput.vue'
  import {mapState} from 'vuex'
  import responseNotification from "../lib/responseNotification";

  import _ from 'lodash'
  import { passback } from '../lib/integration';

  const configLocalStorageKey = 'parkave_config';

  export default {
    name: 'SelfServeUpdates',
    components: {
      Item,
      ArrayItem,
      SizeInput
    },
    beforeRouteEnter (to, from, next) {
      if (store.state.me.id) return next();
      store.dispatch('loadMe').then((me) => {
        if (me.admin || me.format_admin) {
          return store.dispatch('formats/loadAll').then(next)
        } else {
          return next();
        }
      })
    },
    async created(){
      await this.$store.dispatch('advertisements/loadSingle', this.$route.params.advertisement_id);
      await this.$store.dispatch('loadUpdateFields');

      this.getConfigFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem(configLocalStorageKey));
      }

      this.shouldUseLocalStorage = () => {
        return this.$route.params.format_id && !this.$route.params.advertisement_id;
      }

      this.writeConfigToLocalStorage = (config) => {
        localStorage.setItem(configLocalStorageKey, JSON.stringify(config));
      }

      let formatsInterval = setInterval(async function () {
        if (this.$store.getters['formats/unfiltered'].length) {
          clearInterval(formatsInterval);

          this.format = this.$store.getters['formats/unfiltered'].filter((format) => {
            return parseInt(this.$route.params.format_id) === format.id
          })[0]

          if (!this.ad.update_rule_id) {
            this.$router.push('/')
          }

          try {
            if (!this.format && this.$store.getters.isFormatAdmin) {
              this.format = this.$store.state.formats.allFormats.filter((format) => {
                return parseInt(this.$route.params.format_id) === format.id
              })[0]
            }
            this.fields = JSON.parse(this.format.specification).inputs

            for (var key in this.fields) {
              var value = this.fields[key];

              var values = this.ad ? this.ad.json : {};

              if (value.type == 'object') {
                this.$set(this.settings, value.name, {});
              }

              values = JSON.parse(values);

              if (values && value.name in values) {
                this.$set(this.settings, value.name, values[value.name]);
              } else if (value.default) {
                this.$set(this.settings, value.name, value.default);
              }

              this.$set(this.settings, 'name', this.ad.name);

            }
          } catch (e) {
            console.log('error parsing fields', e);
          }

          this.loadedConfigDefaults = true;

          if (!localStorage.getItem(configLocalStorageKey)) this.writeConfigToLocalStorage({});

          let config = this.getConfigFromLocalStorage();
          let thisConfig = null;

          if (this.shouldUseLocalStorage()) {
            let {format_id} = this.$route.params;

            if (format_id in config) {
              thisConfig = config[format_id];
            }

            if (thisConfig) this.$set(this, 'settings', thisConfig);
          }

        }

      }.bind(this), 100);
    },
    methods: {
      sizeItem() {
        for(var key in this.fields) {
          if (this.fields[key].type == 'size') {
            return this.fields[key];
          }
        }
        return null;
      },

      async save(e, insert){
        e.preventDefault();

        let error = function (type) {
          responseNotification({}, {error: 'Please enter a ' + type}, {}, {timeout: 2000})
        }

        if (!this.settings.first_name || this.settings.first_name.length < 3) { error('first name.'); return; }
        if (!this.settings.last_name || this.settings.last_name.length < 3) { error('last name.'); return; }
        if (!this.settings.email || this.settings.email.length < 3 || !this.is_email_valid(this.settings.email)) { error('valid email.'); return; }
        if (!this.settings.title) { error('title.'); return; }
        if (!this.settings.description || this.settings.description.length < 3) { error('description.'); return; }
        if (!this.settings.image) { error('image.'); return; }
        if (!this.settings.link || this.settings.link.length < 3) { error('destination link.'); return; }
        if (!this.settings.scheduled_time) { error('proper time slot for the ad to run.'); return; }

        responseNotification({}, {info: 'Creating ad...'}, {}, {timeout: 4000})

        let payload = {};

        this.update_fields.forEach((field) => {
          payload[field.name] = this.settings[field.name];
        });

        payload.image = this.settings['image'].url;
        payload.meta = this.settings['image'];
        payload.advertisement_id = this.ad.id;
        payload.timezone = window.timezone;

        let finish = ()=>{
          store.dispatch('createUpdate', {data: payload, cb: (response)=>{
            if (!response.errors) {
              this.$router.push('/update_success')
            }
          }});

          let config = this.getConfigFromLocalStorage();

          if(this.shouldUseLocalStorage()){
            let { format_id } = this.$route.params;
            if(format_id in config){
              let newConfig = _.omit(config, [format_id]);

              this.writeConfigToLocalStorage(newConfig);
            }
          }
        }

        finish();
      },
      getFormName(type, index){
        return `${type}-${index}`
      },
      onChangeTime(binding, newVal){
        let { HH, mm, ss } = newVal.data;
        this.settings[binding] = { HH, mm, ss }
      },
      onPreviewData(preview) {
        if (preview.scale) {
          this.$set(this.preview, 'scale', preview.scale);
        }
      },
      is_email_valid (email) {
        var re = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i
        return !!re.test(email)
      },
    },
    watch: {
      sidebarActive: {
        handler(){
          this.$refs.preview.generatePreview()
        }
      },
      settings: {
        deep: true,
        handler(newVal){
          let config = this.getConfigFromLocalStorage();

          if(this.shouldUseLocalStorage() && this.loadedConfigDefaults){
            let { format_id } = this.$route.params;
            config[format_id] = newVal;
            this.writeConfigToLocalStorage(config);
          }
        }
      }
    },
    data () {
      return {
        sidebarActive: true,
        format: {},
        fields: [],
        settings: {},
        meta: {},
        preview: {
          srcdoc: '',
          length: 0,
          scale: 100
        },
        isUpdateable: false
      }
    },
    computed: {
      ...mapState(['update_fields']),
      ...mapState('advertisements', {
        ad: 'single_ad'
      }),
      getSize () {
        let size = this.settings['size'];
        if (size && size.type == 'fixed') {
          return size.width + 'x' + size.height
        } else if (size) {
          return size.width + ':' + size.height
        }
      }
    }
  }
</script>

<style scoped>
    .button--primary, .size__display {
        color: white !important;
    }

    .section--sidebar .form__group {
        height: calc(100vh - 75px);
    }

    .section--sidebar .preview {
        height: calc(100vh - 130px);
    }
    
    @media screen and (max-width: 600px) {
      .section--sidebar .form__group {
        height: 100%;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/SelfServeUpdates.vue